import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import api from "src/utils/axios";
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');
dayjs.extend(utc);
dayjs.extend(timezone);

const initialState = {
  isLoading: false,
  error: null,
  venues: [],
  venue: null,
  reservationVenues: [],
};

const venuesSlice = createSlice({
  name: "venues",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    getVenueSuccess(state, action) {
      state.isLoading = false;
      state.venue = action.payload;
      state.error = null;
    },
    getVenuesSuccess(state, action) {
      state.isLoading = false;
      state.venues = action.payload;
      state.error = null;
    },
    getVenueSuccessForReservation(state, action) {
      state.isLoading = false;
      state.reservationVenues = action.payload;
      state.error = null;
    },
    getVenuesFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default venuesSlice.reducer;

export const { getVenuesSuccess, getVenuesFailure } = venuesSlice.actions;

export function getAllVenues() {
  return async (dispatch) => {
    dispatch(venuesSlice.actions.startLoading());
    try {
      const response = await api.get(
        `${process.env.REACT_APP_BACKEND_URL}/venues/getVenueList`
      );
      dispatch(venuesSlice.actions.getVenuesSuccess(response.data.results));
    } catch (error) {
      dispatch(
        venuesSlice.actions.getVenuesFailure(error.response?.data?.messags)
      );
    }
  };
}
export function getVenue(venueId) {
  return async (dispatch) => {
    dispatch(venuesSlice.actions.startLoading());
    try {
      const response = await api.get(`${process.env.REACT_APP_BACKEND_URL}/venues/${venueId}`)
      dispatch(venuesSlice.actions.getVenueSuccess(response.data));
    } catch (error) {
      dispatch(
        venuesSlice.actions.getVenuesFailure(error.response?.data?.messags)
      );
    }
  };
}

export function getVenueListWithLocation(data) {
  return async (dispatch) => {
    dispatch(venuesSlice.actions.startLoading());
    try {
      let inRadius = false;
      const res = await api.get(`${process.env.REACT_APP_BACKEND_URL}/generalConfiguration/getOneGeneralConfiguration`);
      if (res.data) {
        inRadius = res.data.getVenuesInRadius
      }
      const response = await api.get(
        `${process.env.REACT_APP_BACKEND_URL}/venues/getVenueListWithLocation/`,
        {
          params: {
            location: data,
            page: 1,
            limit: 50,
            configurations: {
              'isPickUp': true
            },
            inRadius
          }
        }
      );
      dispatch(venuesSlice.actions.getVenuesSuccess(response.data.results));
    } catch (error) {
      dispatch(
        venuesSlice.actions.getVenuesFailure(error.response?.data?.messags)
      );
    }
  };
}

export function getVenueListWithLocationAndType(data, type, val) {
  return async (dispatch) => {
    dispatch(venuesSlice.actions.startLoading());
    try {
      let inRadius = false;
      const res = await api.get(`${process.env.REACT_APP_BACKEND_URL}/generalConfiguration/getOneGeneralConfiguration`);
      if (res.data) {
        inRadius = res.data.getVenuesInRadius
      }
      const response = await api.get(
        `${process.env.REACT_APP_BACKEND_URL}/venues/getVenueListWithLocation/`,
        {
          params: {
            location: data,
            limit: 50,
            page: 1,
            configurations: {
              [type]: val
            },
            inRadius
          }
        }
      );
      dispatch(venuesSlice.actions.getVenuesSuccess(response.data.results));
    } catch (error) {
      dispatch(
        venuesSlice.actions.getVenuesFailure(error.response?.data?.messags)
      );
    }
  };
}

export function getVenueListforReservation(location, partySize, time) {
  return async (dispatch) => {
    dispatch(venuesSlice.actions.startLoading());
    try {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const localTime = dayjs.tz(time, timeZone);
      const utcTime = localTime.utc().format();
      const response = await api.post(
        `${process.env.REACT_APP_BACKEND_URL}/venues/reservable/list/b2c?location=${location}`,
        {
          partySize: partySize,
          time: utcTime
        }
      );
      dispatch(venuesSlice.actions.getVenuesSuccess(response.data));

    } catch (error) {
      dispatch(
        venuesSlice.actions.getVenuesFailure(error.response?.data?.messags)
      );
    }
  };
}
